import { gridLayouts, gridColors} from '../constants/gridLayouts';

const gridsList = [
  {
    name: 'Landing Pages',
    description: 'Major breakpoints were defined into media queries that will mark the transition between resolutions or between devices. These breakpoints are set based on analytics of the most used resolutions in the world:',
    breakpoints: [
      '@media (min-width: 320px)  { ... }',
      '@media (min-width: 768px) { ... }',
      '@media (min-width: 1024px) { ... }',
      '@media (min-width: 1366px) { ... }',
      '@media (min-width: 1600px) { ... }',
      '@media (min-width: 1920px) { ... }'
    ],
    items: [
      {
        name: 'Full Width Container',
        image: 'landing_maincontainer+margin',
        file: 'toBeDone.jpg',
        colors: [
          {variation: gridColors['margin'], description: 'margin'},
          {variation: gridColors['red'], description: 'main container'},
        ],
        component: gridLayouts['FullWidthContainer'],
      },
      {
        name: 'Vertical Section Marker and Main Container',
        image: 'landing_verticalsectionmarker+maincontainer',
        file: 'toBeDone.jpg',
        colors: [
          {variation: gridColors['margin'], description: 'margin'},
          {variation: gridColors['red'], description: 'main container'},
          {variation: gridColors['sidenav'], description: 'section marker'},
        ],
        component: gridLayouts['VerticalSectionMarkerMainContainer'],
      }
    ]
  },
  {
    name: 'Selfcare',
    description: 'As seen in the landing pages, breakpoints were defined into media queries. These breakpoints are set based on the analytics of the type of device used on these pages:',
    breakpoints: [
      '@media(min - width: 1024px) { ... }',
      '@media(min - width: 1366px) { ... }',
      '@media(min - width: 1600px) { ... }',
      '@media(min - width: 1920px) { ... }',
    ],
    items: [
      {
        name: 'SideNav and Main Container',
        image: 'selfcare_sidenav+maincontainer',
        file: 'toBeDone.jpg',
        colors: [
          {variation: gridColors['margin'], description: 'margin'},
          {variation: gridColors['red'], description: 'main container'},
          {variation: gridColors['sidenav'], description: 'sidenav'},
        ],
        component: gridLayouts['SideNavMainContainer'],
      },
      {
        name: 'SideNav, 2nd Level and Main Container',
        image: 'selfcare_sidenav+2level+maincontainer',
        file: 'toBeDone.jpg',
        colors: [
          {variation: gridColors['margin'], description: 'margin'},
          {variation: gridColors['red'], description: 'main container'},
          {variation: gridColors['sidenav'], description: 'side nav'},
          {variation: gridColors['extraNav'], description: '2nd level'},
        ],
        component: gridLayouts['SideNavSecLevelMaincontainer'],
      },
      {
        name: 'Steptracker and Main Container',
        image: 'selfcare_steptracker+maincontainer',
        file: 'toBeDone.jpg',
        colors: [
          {variation: gridColors['margin'], description: 'margin'},
          {variation: gridColors['red'], description: 'main container'},
          {variation: gridColors['sidenav'], description: 'step tracker'},
        ],
        component: gridLayouts['StepTrackerMainContainer'],
      },
      {
        name: 'Steptracker, Left Container and Main Container',
        image: 'selfcare_steptracker+left+maincontainer',
        file: 'toBeDone.jpg',
        colors: [
          {variation: gridColors['margin'], description: 'margin'},
          {variation: gridColors['red'], description: 'main container'},
          {variation: gridColors['sidenav'], description: 'step tracker'},
          {variation: gridColors['extraNav'], description: 'side container'},
        ],
        component: gridLayouts['StepTrackerLeftContainerMainContainer'],
      },
      {
        name: 'Steptracker, Left Container, Main Container and Right Container',
        image: 'selfcare_steptracker+left+main+rightcontainer',
        file: 'toBeDone.jpg',
        colors: [
          {variation: gridColors['margin'], description: 'margin'},
          {variation: gridColors['red'], description: 'main container'},
          {variation: gridColors['sidenav'], description: 'step tracker'},
          {variation: gridColors['extraNav'], description: 'side containers'},
        ],
        component: gridLayouts['StepTrackerLeftContainerMainContainerRightContainer'],
      },
      {
        name: 'Steptracker, Left Container, Main Container and Right Container',
        image: 'selfcare_steptracker+map+maincontainer',
        file: 'toBeDone.jpg',
        colors: [
          {variation: gridColors['margin'], description: 'margin'},
          {variation: gridColors['red'], description: 'main container'},
          {variation: gridColors['sidenav'], description: 'step tracker'},
          {variation: gridColors['extraNav'], description: 'map'},
        ],
        component: gridLayouts['StepTrackerMapMainContainer'],
      },
      {
        name: 'Steptracker, Main Container and Right Container',
        image: 'selfcare_steptracker+main+rightcontainer',
        file: 'toBeDone.jpg',
        colors: [
          {variation: gridColors['margin'], description: 'margin'},
          {variation: gridColors['red'], description: 'main container'},
          {variation: gridColors['sidenav'], description: 'step tracker'},
          {variation: gridColors['extraNav'], description: 'side container'},
        ],
        component: gridLayouts['StepTrackerMainContainerRightContainer'],
      },
      {
        name: 'Left Container, Main Container and Right Container',
        image: 'selfcare_left+main+rightcontainer',
        file: 'toBeDone.jpg',
        colors: [
          {variation: gridColors['margin'], description: 'margin'},
          {variation: gridColors['red'], description: 'main container'},
          {variation: gridColors['extraNav'], description: 'side containers'},
        ],
        component: gridLayouts['LeftContainerMainContainerRightContainer'],
      },
      {
        name: 'Left Container and Main Container',
        image: 'selfcare_left+maincontainer',
        file: 'toBeDone.jpg',
        colors: [
          {variation: gridColors['margin'], description: 'margin'},
          {variation: gridColors['red'], description: 'main container'},
          {variation: gridColors['extraNav'], description: 'side container'},
        ],
        component: gridLayouts['LeftContainerMainContainer'],
      },
      {
        name: 'Main Container and Right Container',
        image: 'selfcare_main+rightcontainer',
        file: 'toBeDone.jpg',
        colors: [
          {variation: gridColors['margin'], description: 'margin'},
          {variation: gridColors['red'], description: 'main container'},
          {variation: gridColors['extraNav'], description: 'side container'},
        ],
        component: gridLayouts['RightContainerMainContainer'],
      }

    ]
  }
];

export default gridsList;



// WEBPACK FOOTER //
// ./src/containers/foundations/Grids/constants/gridsList.js